import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/masteradmin/pages/Login'
import CourseList from '@/masteradmin/pages/CourseList'
import ApplicationList from '@/masteradmin/pages/ApplicationList'
import CreateCourse from '@/masteradmin/pages/CreateCourse'

import {
  PAGE_LOGIN,
  PAGE_COURSE_LIST,
  PAGE_APPLICATION_LIST,
  PAGE_CREATE_COURSE,
} from '@/masteradmin/router/routeNames'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: PAGE_LOGIN,
    component: Login,
  },
  {
    path: '/',
    name: PAGE_COURSE_LIST, // PAGE_MASTER
    component: CourseList,
  },
  {
    path: '/applications',
    name: PAGE_APPLICATION_LIST,
    component: ApplicationList,
  },
  {
    path: '/new-course',
    name: PAGE_CREATE_COURSE,
    component: CreateCourse,
  },
].map(route => ({
  ...route,
  path: `/master${route.path}`,
}))

routes.push({
  path: '*',
  redirect: '/master',
})

const router = new Router({
  routes,
  mode: 'history',
})

export default router



// WEBPACK FOOTER //
// ./client/masteradmin/router/index.js